var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStaff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 20.25,
    viewBox: "0 0 17 20.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Staff",
    d: "M7.875,9a4.5,4.5,0,1,0-4.5-4.5A4.5,4.5,0,0,0,7.875,9Zm3.368,2.146-1.68,6.729L8.438,13.094l1.125-1.969H6.188l1.125,1.969L6.188,17.875l-1.68-6.729A4.717,4.717,0,0,0,0,15.85v1.462A1.688,1.688,0,0,0,1.688,19H14.063a1.688,1.688,0,0,0,1.688-1.687V15.85a4.717,4.717,0,0,0-4.507-4.7Z",
    transform: "translate(0.625 0.625)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaff);
export default __webpack_public_path__ + "static/media/Staff.2f7f6626b82b22cf9c25abc27a754972.svg";
export { ForwardRef as ReactComponent };